<!-- 结算管理 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :span="6">
          <span>申请编号：</span>
          <el-input v-model="filter.applyNo" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6">
          <span>提现方名称/手机号：</span>
          <el-input
            v-model="filter.receiveUser"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-radio-group
          style="margin-bottom: 20px"
          v-model="currentType"
          size="small"
          @change="search"
        >
          <el-radio-button
            v-for="item in typeItems"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            prop="applyNo"
            label="申请编号"
            width="200"
          ></el-table-column>
          <el-table-column prop="userName" label="提现方名称"></el-table-column>
          <el-table-column prop="userPhone" label="手机号"></el-table-column>
          <el-table-column
            prop="withdrawAmount"
            label="提现金额"
          ></el-table-column>
          <el-table-column prop="payAmount" label="支付金额"></el-table-column>
          <el-table-column prop="taxFee" label="税费"></el-table-column>
          <el-table-column prop="accountType" label="账户类型">
            <template slot-scope="scope">
              <span>{{ accountTypeList[scope.row.accountType] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiveAccount"
            label="收款账号"
          ></el-table-column>
          <el-table-column
            prop="applyTime"
            label="申请时间"
            width="200"
          ></el-table-column>
          <el-table-column prop="withdrawStatus" label="状态">
            <template slot-scope="scope" v-if="scope.row.withdrawStatus">
              <span v-if="scope.row.withdrawStatus == 1">处理中</span>
              <span v-else>付款成功</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <template>
                <el-button
                  class="edit"
                  type="text"
                  @click="handleDetail(scope.row)"
                  >详情</el-button
                >

                <el-button
                  class="edit"
                  type="text"
                  v-if="scope.row.withdrawStatus == 1"
                  @click="handleOperate(scope.row)"
                  >处理</el-button
                >
                <el-button
                  class="edit"
                  type="text"
                  v-else
                  @click="handleInvalid(scope.row)"
                  >付款记录</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="900px"
      @close="dialogVisible = false"
    >
      <el-form
        :model="detail"
        ref="formRef"
        label-width="120px"
        :inline="false"
      >
        <el-form-item label="提现方名称：" prop="type">
          <div>{{ detail.userName }}</div>
        </el-form-item>
        <el-form-item label="手机号：" prop="type">
          <div>{{ detail.userPhone }}</div>
        </el-form-item>
        <el-form-item label="提现金额：" prop="type">
          <div>{{ detail.withdrawAmount }} 元</div>
        </el-form-item>
        <el-form-item label="税费：" prop="type">
          <div>{{ detail.taxFee }} 元</div>
        </el-form-item>
        <el-form-item label="收款账号：" prop="type">
          <div v-if="detail.accountType">
            {{ accountTypeList[detail.accountType] }}&nbsp;&nbsp;{{
              detail.userName.length > 2
                ? detail.userName.charAt(0) +
                  "*".repeat(detail.userName.length - 2) +
                  detail.userName.slice(-1)
                : detail.userName
            }}&nbsp;&nbsp;{{
              detail.receiveAccount.length > 6
                ? detail.receiveAccount.substring(0, 4) +
                  "*".repeat(detail.receiveAccount.length - 6) +
                  detail.receiveAccount.slice(-2)
                : detail.receiveAccount
            }}
          </div>
        </el-form-item>
        <el-form-item label="发票：" prop="type">
          <div>
            <a :href="detail.invoiceUrl" target="_blank">{{
              detail.invoiceFileName || "发票"
            }}</a>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 处理，付款记录 -->
    <el-dialog
      :title="dialogMode == 'add' ? '处理' : '付款记录'"
      :visible.sync="dialogVisibleOutter"
      width="900px"
      @close="dialogVisibleOutter = false"
      destroy-on-close
    >
      <el-form
        :model="currentData"
        ref="formRefAdd"
        label-width="120px"
        :inline="false"
        :rules="rules"
      >
        <el-form-item label="付款时间：" prop="payTime">
          <el-date-picker
            v-if="dialogMode == 'add'"
            v-model="currentData.payTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <div v-else>{{ currentData.payTime }}</div>
        </el-form-item>
        <el-form-item label="付款状态：" prop="withdrawStatus">
          <div>
            <span v-if="currentData.withdrawStatus == 1">处理中</span>
            <span v-else>付款成功</span>
          </div>
        </el-form-item>
        <el-form-item label="支付金额：" prop="payAmount">
          <div>{{ currentData.payAmount }}</div>
        </el-form-item>
        <el-form-item label="付款流水号：" prop="payNum">
          <el-input
            v-if="dialogMode == 'add'"
            v-model="currentData.payNum"
            style="width: 60%"
          ></el-input>
          <div v-else>{{ currentData.payNum }}</div>
        </el-form-item>
        <el-form-item label="付款账户：" prop="payAccount">
          <el-input
            v-if="dialogMode == 'add'"
            v-model="currentData.payAccount"
            style="width: 60%"
          ></el-input>
          <div v-else>{{ currentData.payAccount }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisibleOutter = false">{{
          dialogMode == "add" ? "取消" : "关闭"
        }}</el-button>
        <el-button
          type="primary"
          v-if="dialogMode == 'add'"
          @click="handleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import { getList, save } from "@/api/settlement";
import { scope } from "@/config/config";
import { accountTypeList } from "@/utils/enum";
export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      // 详情
      accountTypeList,
      detail: {
        name: "",
        fileName: "",
        fileAdress: "",
      },
      loading: true,
      filter: {
        applyNo: "",
        receiveUser: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisibleOutter: false,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      defaultData: {
        payTime: "",
        withdrawStatus: 1,
        payAmount: 0,
        payNum: "",
        payAccount: "",
      },
      currentData: {
        payTime: "",
        withdrawStatus: 1,
        payAmount: 0,
        payNum: "",
        payAccount: "",
      }, // 当前表单数据
      rules: {
        payTime: [
          { required: true, message: "请选择付款时间", trigger: "blur" },
        ],
        payNum: [
          { required: true, message: "请输入付款流水号", trigger: "blur" },
        ],
        payAccount: [
          { required: true, message: "请输入付款账户", trigger: "blur" },
        ],
      },
      payOptions: [
        {
          value: 0,
          label: "微信",
        },
        {
          value: 1,
          label: "支付宝",
        },
        {
          value: 2,
          label: "国版币",
        },
        {
          value: 3,
          label: "线下支付",
        },
      ],
      currentType: "",
      typeItems: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "处理中",
          value: 1,
        },
        {
          label: "付款成功",
          value: 2,
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const { data } = await this.$ajax.get(getList, {
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          applyNo: this.filter.applyNo,
          receiveUser: this.filter.receiveUser,
          withdrawStatus: this.currentType,
        });

        this.tableData = data.data.records;
        this.total = data?.data?.total || 0;
      } catch (error) {
        console.error("获取列表失败:", error);
        this.$message.error("获取列表失败");
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.applyNo = "";
      this.filter.receiveUser = "";
      this.getList();
    },
    handleDetail(row) {
      this.dialogVisible = true;
      this.detail = JSON.parse(JSON.stringify(row));
    },
    handleOperate(row) {
      this.dialogVisibleOutter = true;
      this.currentData = JSON.parse(JSON.stringify(row));
      this.dialogMode = "add";
    },
    handleInvalid(row) {
      this.dialogVisibleOutter = true;
      this.currentData = JSON.parse(JSON.stringify(row));
      this.dialogMode = "visit";
    },
    handleSubmit() {
      this.$refs.formRefAdd
        .validate()
        .then(() => {
          let params = {
            id: this.currentData.id,
            payAmount: this.currentData.payAmount,
            payNum: this.currentData.payNum,
            payAccount: this.currentData.payAccount,
            payTime: this.currentData.payTime,
          };

          this.$ajax.post(save, params).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("操作成功");
              this.getList();
              this.dialogVisibleOutter = false;
            }
          });
        })
        .catch(() => {
          this.$message.error("请填写完整信息");
        });
    },
  },
  mounted() {
    if (this.$route.query.withdrawStatus) {
      this.currentType = this.$route.query.withdrawStatus;
    }
    this.getList();
    /*************  ✨ Codeium Command ⭐  *************/
    /**
     * Lifecycle hook called when the component is mounted.
     * It triggers the initial data fetch by calling getList.
     */
    /******  7082dec8-8c9a-4f67-9acc-5da39fca5a66  *******/
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    background-color: #002b9c;
    border-color: #002b9c;
  }

  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
